const _ = require('lodash');

/*
  Inbound marketing params the web app captures on landing and the server and interstitial forward onto
  redirects and AppsFlyer OneLinks. One allow-list, so a new click id added here lands on every path.
  Only forwarding drops separator-carrying values; the web capture stores them as-is for analytics.
*/

const ATTRIBUTION_PARAM_PREFIXES = ['utm_', 'sm_'];
const ATTRIBUTION_CLICK_ID_PARAMS = ['gclid', 'fbclid', 'msclkid'];

// Returns the lowercased key for an attribution param, or null for any other param.
const getInboundAttributionParamKey = key => {
  const lower = _.toLower(key);
  const isAttributionParam = ATTRIBUTION_PARAM_PREFIXES.some(prefix => lower.startsWith(prefix)) || ATTRIBUTION_CLICK_ID_PARAMS.includes(lower);
  return isAttributionParam ? lower : null;
};

// Accepts an Express req.query or Object.fromEntries(new URLSearchParams(search)); keys come back lowercased.
const getInboundAttributionParams = (query = {}) =>
  _.reduce(
    query,
    (acc, value, key) => {
      const attributionKey = getInboundAttributionParamKey(key);
      const singleValue = _.isArray(value) ? _.last(value) : value;
      if (
        attributionKey &&
        _.isString(singleValue) &&
        singleValue &&
        // Values carrying query separators are malformed at best and param-injection attempts at worst
        !/[&=?#]/.test(singleValue)
      ) {
        acc[attributionKey] = singleValue;
      }
      return acc;
    },
    {}
  );

module.exports = {
  getInboundAttributionParamKey,
  getInboundAttributionParams
};
